import React, { useState } from "react";
import "../../../stylesheets/components/Reports/HoldingReports/FilterAssetDrop.scss";
import { FilterData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { initSelectedFilter, } from "@frameworks/web/components/Reports/CommonComponent/constant";
const LedgerFilter = ({ setshowFilterAssetDropdown, setShowFDot, filterData: { simpleFilter, assetFilter }, setFilterData, applyFilter, showAsset, dynamicFiltersName, parentClass, replacedFilterName, selectedFilterTray, }) => {
    const [filterData, setFilterDATA] = useState({
        simpleFilter,
        assetFilter,
    });
    const [selectedFilters, setselectedFilters] = useState({
        simpleFilter: 0,
        assetFilter: 0,
    });
    const [filterTrayOpen, setFilterTrayOpen] = useState(selectedFilterTray);
    const FiltercounterHelper = (filter, event) => {
        if (!filter)
            return [];
        const { parentNode, checked } = event.target;
        const newFilters = [...filter.filters];
        filter.filters.forEach((el, index) => {
            if (el.title === parentNode.textContent) {
                newFilters[index] = Object.assign(Object.assign({}, el), { selected: checked });
            }
        });
        return newFilters;
    };
    const filterCounter = (event) => {
        let internalFilterData = Object.assign({}, filterData);
        internalFilterData.simpleFilter.filters = FiltercounterHelper(internalFilterData.simpleFilter, event);
        setselectedFilters((prevState) => {
            return Object.assign(Object.assign({}, prevState), { simpleFilter: internalFilterData.simpleFilter.filters.filter((x) => x.selected).length });
        });
        if (showAsset)
            internalFilterData.assetFilter.filters = FiltercounterHelper(internalFilterData.assetFilter, event);
        if (showAsset)
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: internalFilterData.assetFilter.filters.filter((x) => x.selected).length });
            });
        else
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: 0 });
            });
        setFilterDATA((prevState) => {
            let state = {
                simpleFilter: internalFilterData.simpleFilter,
                assetFilter: internalFilterData.assetFilter,
            };
            return state;
        });
    };
    const applyFilterHandle = () => {
        applyFilter(filterData, filterTrayOpen);
        if (!showAsset) {
            setselectedFilters((prevState) => {
                return Object.assign(Object.assign({}, prevState), { assetFilter: 0 });
            });
        }
        setshowFilterAssetDropdown(false);
        let count = Object.values(selectedFilters).reduce((prevFilterCount, currCount) => prevFilterCount + currCount, 0);
        setShowFDot(count);
        setFilterData(filterData);
    };
    const removeFilter = (filter) => {
        return filter === null || filter === void 0 ? void 0 : filter.map((filter) => {
            if (filter.selected)
                filter.selected = false;
            return filter;
        });
    };
    const clearAllFilter = () => {
        setselectedFilters(initSelectedFilter);
        let clearState = new FilterData({
            name: simpleFilter.name,
            filters: removeFilter(simpleFilter.filters),
        }, {
            name: assetFilter.name,
            filters: removeFilter(assetFilter === null || assetFilter === void 0 ? void 0 : assetFilter.filters),
        });
        sessionStorage.removeItem("simpleFilter");
        sessionStorage.removeItem("assetFilter");
        setFilterData(clearState);
        applyFilter(clearState, {
            simpleFilter: true,
            assetFilter: false,
        });
        setshowFilterAssetDropdown(false);
        setShowFDot(0);
    };
    const arrow = (e, filterName) => {
        e.stopPropagation();
        let temp = Object.assign({}, filterTrayOpen);
        for (let key in temp)
            if (key === filterName)
                temp[key] =
                    !temp[key];
            else
                temp[key] = false;
        setFilterTrayOpen(temp);
    };
    const showOrHide = (filterName) => {
        Object.entries(replacedFilterName).forEach((x) => {
            if (filterName === x[1])
                filterName = x[0];
        });
        return filterTrayOpen[filterName];
    };
    const DynamicFilters = (filters) => {
        var _a, _b;
        if (filters && filters.name && ((_a = filters.filters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let Filtercount = 0;
            let showFilter = showOrHide(filters.name);
            Object.entries(replacedFilterName).forEach((x) => {
                if (filters.name === x[1])
                    Filtercount = selectedFilters[x[0]];
            });
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { id: "filter", className: "filterasset-drop-head position-relative" },
                    React.createElement("p", { onClick: (e) => {
                            arrow(e, filters.name);
                        } },
                        dynamicFiltersName[filters.name],
                        React.createElement("span", { className: Filtercount > 0 ? "txt-midnight-blue" : "" }, `(${Filtercount})`)),
                    React.createElement("span", { onClick: (e) => {
                            arrow(e, filters.name);
                        } }, showFilter ? (React.createElement("i", { className: "edel-icon-arrow-up arr-color" })) : (React.createElement("i", { className: "edel-icon-arrow-down arr-color" })))),
                React.createElement("div", { id: "filter", className: `filterasset-drop-body h-auto ${showFilter ? "show" : "hide"}` },
                    React.createElement("ul", null, (_b = filters === null || filters === void 0 ? void 0 : filters.filters) === null || _b === void 0 ? void 0 : _b.map((val, idx) => {
                        return (React.createElement("li", { key: idx },
                            React.createElement("label", { className: "checkbox" },
                                React.createElement("input", { type: "checkbox", checked: val.selected, onChange: filterCounter }),
                                React.createElement("span", { className: "checked edel-icon-tick" }),
                                React.createElement("p", null, val.title))));
                    })))));
        }
    };
    const enableApply = () => {
        for (let key in selectedFilters)
            if (selectedFilters[key] > 0)
                return true;
        return false;
    };
    const InitSelectedFilters = () => {
        let filterCounts = {
            simpleFilter: 0,
            assetFilter: 0,
        };
        for (let key in filterData) {
            if (filterData[key]) {
                let filterCount = filterData[key].filters.filter((x) => x.selected).length;
                if (filterCount > 0)
                    filterCounts[key] = filterCount;
            }
        }
        setselectedFilters(filterCounts);
    };
    React.useEffect(() => {
        InitSelectedFilters();
    }, []);
    return (React.createElement("div", { className: `filterasset-drop ${parentClass ? parentClass : null}` },
        React.createElement("div", { className: "drop-arrow" }),
        Object.entries(filterData).map((val) => {
            React.createElement("div", { className: "filter-asset-seperator" });
            if (val[0] == "assetFilter")
                return showAsset && DynamicFilters(val[1]);
            return DynamicFilters(val[1]);
        }),
        React.createElement("div", { className: "filterasset-drop-footer" },
            React.createElement("input", { className: "filter-button", type: "button", value: "Clear All", onClick: clearAllFilter }),
            React.createElement("input", { className: enableApply() ? "filter-button aply-btn" : "filter-button-disable", type: "button", value: "Apply", onClick: applyFilterHandle }))));
};
export default React.memo(LedgerFilter);
